import {
	IsNotEmpty,
	IsString,
	Matches,
	NotEquals,
	Validate,
	ValidateIf,
	ValidationArguments,
	ValidatorConstraint,
	ValidatorConstraintInterface
} from 'class-validator';
import { ConnectorConfig } from '../../../models';
import {
	hasAnyCloudinaryCredentialField,
	hasCompleteCloudinaryCredentials,
	requiresCloudinaryCredentials
} from '../cloudinary-credentials.util';

const CREDENTIAL_MASK = '**************';

@ValidatorConstraint({ name: 'hasCompleteCloudinaryCredentials', async: false })
export class HasCompleteCloudinaryCredentials implements ValidatorConstraintInterface {
	validate(_value: string | undefined, arguments_: ValidationArguments): boolean {
		return !requiresCloudinaryCredentials(arguments_.object) || hasCompleteCloudinaryCredentials(arguments_.object);
	}

	defaultMessage(): string {
		return 'Cloudinary custom authentication requires all of cloud name, API key, and API secret.';
	}
}

export class ConnectorConfigCloudinary extends ConnectorConfig {
	/* Target should be the path structure for Cloudinary to a particular folder. */
	@IsString()
	target: string;

	@ValidateIf(config => hasAnyCloudinaryCredentialField(config))
	@IsString()
	@IsNotEmpty()
	@Matches(/^[A-Za-z0-9_-]+$/)
	@Validate(HasCompleteCloudinaryCredentials)
	environment?: string;

	/* Required alongside the cloud name, except on a credential-pending import:
	   see requiresCloudinaryCredentials. */
	@ValidateIf(config => requiresCloudinaryCredentials(config))
	@IsString()
	@IsNotEmpty()
	@Matches(/\S/)
	@NotEquals(CREDENTIAL_MASK)
	accessToken?: string;

	@ValidateIf(config => requiresCloudinaryCredentials(config))
	@IsString()
	@IsNotEmpty()
	@Matches(/\S/)
	@NotEquals(CREDENTIAL_MASK)
	apiSecret?: string;

	// Other properties specific to Cloudinary...
}
